import BreadCrumb from "../components/BreadCrumb/BreadCrumb";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import useDataGrid from "../hooks/useDataGrid";
import Teams from "./Teams";
import ControlledDataGridComponent from "../components/tables/controlledDataGrid";
import { getAllProyectsBilling, removeProyectBilling } from "../redux/slices/facturacion";
import ProyectBilling from "../components/modal/ProyectBilling";
import { getAllPaises } from "../redux/slices/paises";
import { getAllRegions } from "../redux/slices/regions";

const permitedRenderDataColumn = [
  { title: "ID", value: "id", hide: true },
  { title: "Nombre", value: "nombre" },
  { title: "Pais", value: "pais_nombre" },
  { title: "Region", value: "region_nombre" },
  { title: "Comuna", value: "comuna_nombre" },
  { title: "Acciones", value: "acciones_inv" },
];

export const FacturacionProyectos = () => {
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });

  const { facturacionProyectos, success } = useSelector((state) => state.facturacion);
  const { data } = useSelector((state) => state.regions);
  const dispatch = useDispatch();
  const [handleElementClick, setHandleElementClick] = useState({ status: false });

  const handleDelete = (params) => {
    const id = params.id;
    dispatch(removeProyectBilling(id));
  };

  const [columns] = useDataGrid(
    permitedRenderDataColumn,
    handleDelete,
    "Facturacion Proyectos",
    false,
    setHandleElementClick
  );

  useEffect(() => {
    dispatch(getAllProyectsBilling(paginationModel));
    dispatch(getAllPaises());
    dispatch(getAllRegions());
  }, [dispatch, paginationModel.page]);

  return (
    <div>
      <div className="flex justify-between my-2 items-center bg-[#2b2c84]/20 px-5 py-2 rounded">
        <div>
          <h1 className="font-semibold text-[#1E293B] text-2xl">Proyectos</h1>
          <BreadCrumb origin={"Mantenedores"} current={"Proyectos"} />
        </div>
        <div>
          <ProyectBilling type={"create"} />
          <ProyectBilling
            type={"edit"}
            open={handleElementClick.status}
            data={handleElementClick.data}
            setOpen={setHandleElementClick}
          />
        </div>
      </div>
      <ControlledDataGridComponent
        paginationModel={paginationModel}
        setPaginationModel={setPaginationModel}
        columns={columns}
        rows={facturacionProyectos}
        success={success}
      />
    </div>
  );
};

export default FacturacionProyectos;
